<template>
    <div
        class="drag-pipeline-columns"
        :id="pipeline._id"
        ref="pipeline"
        :style="[
            moving && {
                border: '3px dotted rgb(163, 163, 170)',
                backgroundColor: 'rgb(163 163 170 / 20%)',
                borderRadius: '8px',
            },
            { '--pipeline-color': pipeline.color },
            { '--pipeline-bg-color': taskBackgroundColor() },
        ]"
    >
        <div
            class="drag-pipeline-column-head"
            :style="{
                backgroundColor: taskBackgroundColor(),
                borderLeft: `7px solid ${pipeline.color || 'black'}`,
            }"
            :type="pipeline.type"
        >
            <div class="pipeline-head-content">
                <div class="pipeline-details">
                    <div class="pipeline-detail">
                        <div class="column-check" v-if="pipeline.isNewColumn || editMode">
                            <div class="pipeline-picker" :style="{ '--row-color': pipeline.color }">
                                <div class="material-icons">palette</div>
                                <input type="color" style="opacity: 0" v-model="pipeline.color" />
                            </div>
                            <a-input
                                :placeholder="$t('task.writeSomething')"
                                class="basic-task-input"
                                v-model="pipeline.name"
                            />
                        </div>
                        <div class="column-check" v-else>
                            <a-checkbox
                                class="kanban-checkbox"
                                :indeterminate="indeterminate"
                                :checked="selected"
                                @change="checkedAllRows"
                            />
                            {{ pipeline.name }}
                        </div>
                        <div class="drag-pipeline-column-rows-length" v-if="!pipeline.isNewColumn && !editMode">
                            {{ pipeline.taskCount }} {{ $t("task.task") }}
                        </div>
                    </div>
                </div>
                <div class="column-options">
                    <a-popover
                        overlayClassName="task-more-options"
                        v-if="!pipeline.isNewColumn && !editMode"
                        trigger="click"
                        placement="bottomRight"
                    >
                        <div slot="content">
                            <div class="options-item" v-if="isUpdatePermission" @click="openEditMode">
                                <div class="material-icons">edit</div>
                                {{ $t("settings.edit") }}
                            </div>
                            <div
                                class="options-item"
                                v-if="isDeletedColumn() && isDeletePermission"
                                @click="deleteColumn"
                            >
                                <div class="material-icons">delete</div>
                                {{ $t("chatbotv2.delete") }}
                            </div>
                        </div>
                        <div class="column-options">
                            <div class="task-more material-icons">more_vert</div>
                        </div>
                    </a-popover>
                    <div class="column-options" v-if="pipeline.isNewColumn || editMode" @click="createPipeline">
                        <div class="task-more material-icons">check</div>
                    </div>
                    <div class="column-options" v-if="pipeline.isNewColumn || editMode" @click="deletePipeline">
                        <div class="task-more material-icons">close</div>
                    </div>
                    <div
                        class="column-options"
                        v-if="!pipeline.isNewColumn && !editMode && isCreatePermission && pipeline.type !== 'completed'"
                        @click="$feature.beforeCreateTaskColumn(addNewColumn, getPipelineCount())"
                    >
                        <div class="task-more material-icons">add</div>
                    </div>
                </div>
            </div>
            <div class="basic-task-container" v-if="!pipeline.isNewColumn && !editMode">
                <div
                    class="basic-task-add"
                    v-if="isCreatePermission"
                    @click="$feature.beforeCreateTaskRow(() => createTaskForm('external'), pipeline.taskCount)"
                >
                    <span class="material-icons"> add </span>
                </div>
            </div>
        </div>

        <BasicTask
            v-if="isTaskFormActive('external')"
            :pipelineStageId="pipeline._id"
            :workflow-id="workflowId"
            @close="() => closeTaskForm('external')"
        />
        <draggable
            v-if="!pipeline.isNewColumn"
            :options="groupTaskItemDragOptions"
            v-model="pipeline.tasks"
            :id="pipeline._id"
            :key="pipeline._id"
            @end="moveActionEnd"
            group="tasks"
            class="supsis-draggable-card"
            ref="pipeline"
        >
            <transition-group name="fade" tag="div" class="drag-pipeline-rows" :id="`${pipeline._id}`">
                <TaskCard
                    v-for="task of pipeline.tasks"
                    :key="task._id"
                    :item="task"
                    :pipeline="pipeline"
                    :workflow-id="workflowId"
                    class="task-card"
                    @delete-item="deleteTaskModalOpen"
                    @confirm-item="confirmModelOpen"
                    @archived-item="archivedTask"
                    @change-workflow="changeWorkflow"
                    @to-completed="toCompleted"
                />
                <div
                    v-if="!isTaskFormActive('internal') && !pipeline.isNewColumn && !editMode && isCreatePermission"
                    class="basic-task-add no-drag"
                    key="add-button-inside"
                    @click="$feature.beforeCreateTaskRow(() => createTaskForm('internal'), pipeline.taskCount)"
                >
                    <span class="material-icons">add</span>
                    <span style="margin-left:8px">Konu Oluştur</span>
                </div>
                <BasicTask
                    v-if="isTaskFormActive('internal')"
                    :key="'basic-task-form'"
                    class="no-drag"
                    :pipelineStageId="pipeline._id"
                    :workflow-id="workflowId"
                    @close="() => closeTaskForm('internal')"
                />
            </transition-group>
        </draggable>


        <DeleteModal
            v-if="deleteColumnModal"
            :description="$t('task.deleteColumnCont')"
            :btnCancelText="$t('message.cancel')"
            :btnoktext="$t('message.delete')"
            @cancel="deleteColumnModal = false"
            @confirm="deletePipelineFn(false)"
        />
        <DeleteModal v-if="deleteTransportModal" @cancel="deleteTransportModal = false" :modalBtnVisible="false">
            <div v-if="transportTaskBtn">
                <a-button key="submit" type="danger" @click="transportColumnVisibility">
                    {{ $t("task.moveAndDeleteTask") }}
                </a-button>
                <a-button key="submit" type="danger" @click="deletePipelineFn(true)"> {{$t("task.justDelete")}} </a-button>
            </div>
            <div v-if="transportTaskNewColumn" class="kanban-task-transport-select">
                <p>{{ $t("task.selectColumnMoveTask") }}</p>
                <a-select
                    class="classic-new-select"
                    v-model:value="newTaskPositionId"
                    style="margin-bottom: 10px; width: 200px"
                >
                    <a-select-option v-for="item in defaultWorkflow.pipeline" :key="item._id" :value="item._id">
                        {{ item.name }}
                    </a-select-option>
                </a-select>
                <a-button key="submit" type="danger" @click="deletePipelineFn(true)">Sil</a-button>
            </div>
        </DeleteModal>
    </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import TaskCard from "./TaskCard.vue";
import BasicTask from "../../../../components/task/BasicTaskForm";
import Draggable from "vuedraggable";
import DeleteModal from "./DeleteModal.vue";
import { PERMISSION_TYPES } from "../../../../language/permissionTypes";

export default {
    name: "TaskColCard",
    components: {
        TaskCard,
        BasicTask,
        Draggable,
        DeleteModal,
    },
    props: {
        workflowId: {
            type: String,
            default: null,
        },
        pipeline: {
            type: Object,
            default: {},
        },
        moving: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            prevIndex: null,
            prevGroupId: null,
            prevTaskList: [],
            groupTaskItemDragOptions: {
                tasks: "tasks",
                animation: 100,
                draggable: ".task-card",
                filter: ".no-drag, .basic-task-add, .basic-task",
                preventOnFilter: true
            },
            selected: false,
            indeterminate: false,
            editMode: false,
            options: [
                {
                    value: "todo",
                    label: this.$t("task.todo"),
                },
                {
                    value: "in-progress",
                    label: this.$t("task.inProgress"),
                },
                {
                    value: "approval",
                    label: this.$t("task.approval"),
                },
                {
                    value: "completed",
                    label:this.$t("task.completed"),
                },
            ],
            listeners: [],
            deleteColumnModal: false,
            deleteTransportModal: false,
            newTaskPositionId: null,
            transportTaskNewColumn: false,
            transportTaskBtn: true,
            workflowPerm: null,
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
            users: (state) =>
                state.user.users.data.reduce((acc, user) => {
                    acc[user._id] = user;
                    return acc;
                }, {}),
            defaultWorkflow: (state) => state.tasks.defaultWorkflow,
            basicTaskForm: (state) => state.tasks.basicTaskForm,
            checkedItems: (state) => state.tasks.checkedTasks,
            workflows: (state) =>
                state.tasks.workflows.reduce((acc, workflow) => {
                    acc[workflow._id] = workflow;
                    return acc;
                }, {}),
        }),
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
        isUpdatePermission() {
            return this.checkPermission(PERMISSION_TYPES["task.update"].tr.name);
        },
        isDeletePermission() {
            return this.checkPermission(PERMISSION_TYPES["task.delete"].tr.name);
        },
        isCreatePermission() {
            return this.checkPermission(PERMISSION_TYPES["task.create"].tr.name);
        },
    },

    methods: {
        ...mapActions({
            deletePipelineStage: "tasks/deletePipelineStage",
            setCheckedTasks: "tasks/setCheckedTasks",
            setBasicTaskForm: "tasks/setBasicTaskForm",
        }),
        getPipelineCount() {
            const workflow = this.workflows[this.workflowId];
            return workflow.pipeline.length;
        },
        taskBackgroundColor() {
            let color = this.pipeline.color || "#000000";
            let codes = color.slice(1);
            let first = parseInt(codes.slice(0, 2), 16);
            let second = parseInt(codes.slice(2, 4), 16);
            let third = parseInt(codes.slice(4, 6), 16);
            return `rgba(${first}, ${second}, ${third}, 0.2)`;
        },
        addNewColumn() {
            this.$emit("pipeline-form", this.pipeline);
        },
        isTaskFormActive(context) {
            return this.basicTaskForm[this.pipeline._id]?.context === context;
        },
        createTaskForm(context) {
            const workflow = this.workflows[this.workflowId];
            const permissions = ["createTask", "editTask", "draggingTask", "deleteTask"].map(
                (permission) => workflow.permissions[permission]
            );
            const perm = permissions.every((permission) => permission.length === 0);
            if (perm || permissions[0].includes(this.user._id)) {
                this.setBasicTaskForm({
                    [this.pipeline._id]: {
                        enabled: true,
                        context: context,
                        form: this.basicTaskForm[this.pipeline._id]?.form || {},
                    },
                });
            } else {
                this.$notification.error({
                    message: this.$t("task.createTaskError"),
                    description: this.$t("task.createTaskErrorDesc"),
                });
            }
        },

        closeTaskForm(context) {
            if (this.basicTaskForm[this.pipeline._id]?.context === context) {
                this.setBasicTaskForm({
                    [this.pipeline._id]: {
                        enabled: false,
                        context: null,
                        form: {},
                    },
                });
            }
        },
        deleteTaskModalOpen(task) {
            const workflow = this.workflows[this.workflowId];
            const permissions = ["createTask", "editTask", "draggingTask", "deleteTask"].map(
                (permission) => workflow.permissions[permission]
            );
            const perm = permissions.every((permission) => permission.length === 0);
            if (perm || permissions[3].includes(this.user._id)) {
                this.$emit("delete-modal-task", task);
            } else {
                this.$notification.error({
                    message: this.$t("task.deleteTaskError"),
                    description: this.$t("task.deleteTaskErrorDesc"),
                });
            }
        },
        confirmModelOpen(task) {
            const workflow = this.workflows[this.workflowId];
            const permissions = ["createTask", "editTask", "draggingTask", "deleteTask", "archiveTask", "doneTask"].map(
                (permission) => workflow.permissions[permission],
            );
            const perm = permissions.every((permission) => permission.length === 0);
            if (perm || permissions[5].includes(this.user._id)) {
                this.$emit("confirm-modal-task", task);
            } else {
                this.$notification.error({
                    message: "Görev Kapatma Yetkiniz Yok.",
                    description: "Görevi kapatmak için yetkiniz yok yöneticinizle iletişime geçiniz",
                });
            }
        },
        archivedTask(task) {
            const workflow = this.workflows[this.workflowId];
            const permissions = ["createTask", "editTask", "draggingTask", "deleteTask", "archiveTask"].map(
                (permission) => workflow.permissions[permission],
            );
            const perm = permissions.every((permission) => permission.length === 0);
            if (perm || permissions[4].includes(this.user._id)) {
                this.$emit("archived-modal-task", task);
            } else {
                this.$notification.error({
                    message: "Görev Arşivleme Yetkiniz Yok",
                    description: "Görevi arşivlemek için yetkiniz yok yöneticinizle iletişime geçiniz",
                });
            }
        },
        changeWorkflow(task) {
            this.$emit("change-workflow-task", task);
        },
        toCompleted(task) {
            this.$emit("to-completed-task", task);
        },
        moveActionEnd(event) {
            const workflow = this.workflows[this.workflowId];
            const permissions = ["createTask", "editTask", "draggingTask", "deleteTask"].map(
                (permission) => workflow.permissions[permission]
            );
            const perm = permissions.every((permission) => permission.length === 0);
            if (perm || permissions[2].includes(this.user._id)) {
                this.$emit("moved", event);
            } else {
                this.$notification.error({
                    message: this.$t("task.moveTaskError"),
                    description: this.$t("task.moveTaskErrorDesc"),
                });
                this.$emit("move-back", event);
            }
        },
        checkedAllRows(e) {
            this.selected = this.pipeline.tasks.length > 0 && e.target.checked;
            this.setCheckedTasks({
                ...this.checkedItems,
                ...this.pipeline.tasks.reduce((acc, task) => {
                    acc[task._id] = e.target.checked;
                    return acc;
                }, {}),
            });
        },
        deletePipeline() {
            if (!this.editMode) {
                this.$emit("delete-pipeline", this.pipeline);
            }
            this.editMode = false;
        },
        createPipeline() {
            if (!this.editMode) {
                this.$emit("create-pipeline", this.pipeline);
            } else {
                this.$emit("update-pipeline", this.pipeline);
                this.editMode = false;
            }
        },
        openEditMode() {
            if (!this.pipeline.isNewColumn) {
                this.editMode = !this.editMode;
            }
        },
        isDeletedColumn() {
            return this.defaultWorkflow.pipeline.filter((item) => item.type === this.pipeline.type).length > 1;
        },
        deleteColumn() {
            if (this.pipeline.taskCount === 0) {
                this.deleteColumnModal = true;
            } else if (this.pipeline.taskCount > 0) {
                this.deleteTransportModal = true;
            } else {
                this.deleteColumnModal = false;
            }
        },
        deletePipelineFn(transport) {
            this.deleteColumnModal = false;
            this.deleteTransportModal = false;
            this.deletePipelineStage({
                pipelineId: this.pipeline._id,
                workflowId: this.defaultWorkflow._id,
                newTaskPositionId: transport ? this.newTaskPositionId : null,
            });
        },
        transportColumnVisibility() {
            this.transportTaskNewColumn = true;
            this.transportTaskBtn = false;
        },
        getPipelineTypes() {
            const isExits = this.defaultWorkflow.pipeline.filter((item) => item.type === this.pipeline.type).length;
            const types = [
                { value: "todo", label: "Todo" },
                { value: "in-progress", label: "In Progress" },
                { value: "approval", label: "Approval" },
                // { value: "completed", label: "Completed" },
            ];
            if (isExits > 1) {
                return types;
            } else {
                return types.filter((item) => item.value == this.pipeline.type);
            }
        },
    },
    mounted() {
        this.workflowPerm = this.workflows[this.workflowId];
        const fn = (e) => {
            if (e.code === "Escape") {
                this.editMode = false;
                this.closeTaskForm();
            }
        };
        document.addEventListener("keydown", fn);
        this.listeners.push(() => {
            document.removeEventListener("keydown", fn);
        });
    },
    beforeDestroy() {
        this.listeners.forEach((fn) => fn());
    },
    watch: {
        checkedItems: {
            deep: true,
            handler() {
                this.selected =
                    this.pipeline.tasks.length > 0 && this.pipeline.tasks.every((task) => this.checkedItems[task._id]);
                this.indeterminate =
                    this.pipeline.tasks.length > 0 &&
                    !!this.pipeline.tasks.find((task) => !this.checkedItems[task._id]) &&
                    !!this.pipeline.tasks.find((task) => this.checkedItems[task._id]);
            },
        },
    },
};
</script>
<style lang="scss">
.drag-pipeline-columns {
    &:hover {
        .basic-task-add {
            opacity: 1;
            visibility: visible;
        }
    }

    .basic-task-add {
        opacity: 0;
        visibility: hidden;
        transition: all 0.2s ease;

        display: flex;
        align-items: center;
        padding: 8px;
        cursor: pointer;
        &:hover {
            background-color: var(--color-bg-neutral-hover);
        }
    }

    .task-pipeline-type {
        width: 100%;
        margin-top: 10px;
        .classic-new-select {
            width: 100% !important;
            font-weight: bold;
            [role="combobox"] {
                padding: 4px;
                border: none !important;
                border-radius: 4px !important;
                background-color: var(--white) !important;
            }
        }
    }
    .supsis-draggable-card {
        background: var(--color-bg-neutral-default);
    }

    .pipeline-picker {
        width: 25px;
        height: 25px;
        border-radius: 4px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        input {
            position: absolute;
            z-index: 2;
        }
        .material-icons {
            z-index: 1;
            color: var(--row-color);
        }
    }
}
.kanban-task-transport-select {
    text-align: center !important;
    p {
        font-weight: bold !important;
        margin-bottom: 10px !important;
    }
}
.no-drag {
    user-select: none;
    cursor: default !important;

    touch-action: none;

    &.sortable-chosen {
        cursor: default !important;
    }
}
</style>
